import IEngine from "../IEngine";
import IAudio from "../IAudio";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import PixiAudio from "./PixiAudio";
import IApp from "../IApp";
import ISymbols from "./ISymbols";
import EngineDebug from "../EngineDebug";

@injectable()
export default class PixiEngine implements IEngine {

    audio: IAudio;
    app: IApp;
    symbols: ISymbols;
    debug: EngineDebug;

    constructor(
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: PixiAudio,
        @inject(SERVICE_IDENTIFIER.EngineApp) app: IApp,
        @inject(SERVICE_IDENTIFIER.EngineAppSymbols) symbols: ISymbols,
        @inject(SERVICE_IDENTIFIER.EngineDebug) debug: EngineDebug
    ) {

        this.audio = audio;
        this.app = app;
        this.symbols = symbols;
        this.debug = debug;
    }
}